/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-21 15:59:48
 */

export default [{
	path: 'deliveryReview',
	component: () => import( /* webpackChunkName: "company-list" */ '@/pages/delivery/review/index'),
	meta: {
		title: '交付审核',
		cate: '结算管理'
	},
	children: [{
		path: 'deliveryPersonnelList',
		component: () => import( /* webpackChunkName: "article-create" */
			'@/pages/delivery/personnelList/index'),
		meta: {
			title: '审核列表',
			cate: '结算管理'
		},
	}, {
		path: 'deliveryPrivatePersonnelList',
		component: () => import( /* webpackChunkName: "company-list" */
			'@/pages/delivery/privatePersonnelList/index'),
		meta: {
			title: '审核列表',
			cate: '结算管理'
		}
	}, {
		path: 'deliveryPersonnelDetail',
		component: () => import( /* webpackChunkName: "company-list" */
			'@/pages/delivery/personnelList/detail'),
		meta: {
			title: '详情',
			cate: '结算管理'
		}
	}, {
		path: 'deliveryPrivatePersonnelDetail',
		component: () => import( /* webpackChunkName: "company-list" */
			'@/pages/delivery/privatePersonnelList/detail'),
		meta: {
			title: '详情',
			cate: '结算管理'
		}
	}, ]
}]